import React from 'react'

export default function MyModal(props) {
    return (


            
            <div class="modal fade" id={`${props.mID}Modal`} tabindex="-1" role="dialog" 
            aria-labelledby={`${props.mID}ModalLabel`} aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id={`${props.mID}ModalLabel`}>{props.title}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    {props.children}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" onClick={props.actionButonClick}>{props.actionButtonText}</button>
                </div>
                </div>
            </div>
            </div>

    )
}



// WEBPACK FOOTER //
// ./src/components/MyModal.js